import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { AdditionalFieldForm, DivisionBasicSettingsForm } from './form.model';

@Injectable({ providedIn: 'root' })
export class DivisionBasicSettingsFormValidatorsService {
    public nameTakenValidator(uuid: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const divisionBasicSettingsForm = control?.parent?.parent?.parent as FormGroup<DivisionBasicSettingsForm>;

            let valueAlreadyClaimed = false;

            if (divisionBasicSettingsForm) {
                valueAlreadyClaimed =
                    divisionBasicSettingsForm.controls.additionalFields
                        .getRawValue()
                        .filter(({ name, id }) => name === control.getRawValue() && id !== uuid).length > 0 &&
                    control.getRawValue() !== '';
            }

            return valueAlreadyClaimed ? { nameTaken: true } : null;
        };
    }

    public additionFieldValueRequiredValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const parentForm = control.parent as FormGroup<AdditionalFieldForm>;
            if (parentForm) {
                const picklistValidation = parentForm.getRawValue().type === 'picklist';
                const sourceType: 'Static' | 'User' | undefined = parentForm.getRawValue().source;

                if (sourceType === 'User') {
                    return null;
                }
                if (picklistValidation) {
                    return parentForm?.controls?.picklistElements.length < 1 ? { required: true } : null;
                }
                return control.getRawValue() === '' ? { required: true } : null;
            } else {
                return { required: true };
            }
        };
    }
}
